<template>
<div id="main">
  <div class="about-header">
    <img class="slogan" src="../assets/imgs/about-logo.png">
  </div>

  <div class="about-company">
    <div class="body">
      <div class="title">公司介绍</div>
      <p class="content">上上签（www.666visa.cn） 隶属于深圳市六六六国际旅行社有限公司，成立于2015年7月。在国内首创同业智能便捷办签平台，创始团队来自于腾讯、微软、网易等知名互联网企业。目前已获深圳博汇源、原创资本6000万B轮融资。</p>
      <p class="content">团队自主研发的智能办签SaaS平台，主要面向旅游同业客户。致力于运用技术手段，提升签证行业效率。通过全面实现签证办理流程电子化，智能化来解决传统签证行业办理痛点，为同业旅行社和终端用户都提供了极大的便利。</p>
      <p class="content">目前上上签办签平台支持同业客户在线办理签证并上传保存旅客资料。同步支持电脑端和微信小程序，降低签证办理难度，提升效率，打造一键式办签体验。</p>
      <p class="content">公司于2019年10月荣获“国家级高新技术企业”称号。</p>
    </div>
  </div>

  <div class="about-footer">
    <div class="title">商务合作</div>

    <div class="clearfix body">
      <img src="../assets/imgs/about-map.png" alt="" class="fr map">

      <div class="left">
        <div class="concat">深圳市南山区大冲商务中心A座</div>
        <div class="concat">0755-26919327</div>
        <div style="margin-top:10px;margin-left: 25px;">（{{customer_service.working_time}}）</div>

        <hr>

        <ul>
          <li>同业申请：<span>zhiqiang.guo@idsuipai.com</span></li>
          <li>合作申请：<span>gary.gao@idsuipai.com</span></li>
          <li>产品建议：<span>roy.zhou@idsuipai.com</span></li>
        </ul>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {

    };
  },
  computed: {
    ...mapState('config', [
      'customer_service',
    ]),
  },
  watch: {
    '$route.query.target': function watch(nv) {
      if (nv === 'work') {
        const workEl = this.$el && this.$el.querySelector('.about-footer');
        const workTop = workEl ? workEl.offsetTop : 0;
        scrollTo(0, workTop);
      }
    },
  },
  mounted() {
    if (this.$route.query.target === 'work') {
      const workEl = this.$el && this.$el.querySelector('.about-footer');
      const workTop = workEl ? workEl.offsetTop : 0;
      scrollTo(0, workTop);
    }
  },
};
</script>

<style lang="less">
@import  '../assets/less/variable';

.about-wrap{
  .about-header{
    height:506px;
    background:url(../assets/imgs/about-banner1.png) #fcfcfc no-repeat center bottom;
    margin-top:-60px;
    padding-top:60px;
    text-align:center;

    &::before{
      content:"";
      vertical-align:middle;
      display:inline-block;
      height:100%;
    }

    .slogan{
      vertical-align:middle;
      margin-top:-15px;
    }
  }

  .about-company{
    background-color:#fcfcfc;
    padding:60px 0 50px 0;

    .body{
      width:940px;
      margin:0 auto;
      padding:56px 59px;
      position:relative;
      min-height:340px;
      border:1px solid #aaa;
    }

    .title{
      font-size:24px;
      line-height:24px;
      color:#333;
      position:absolute;
      background-color:#fcfcfc;
      width:160px;
      text-align:center;
      top:-13px;
      left:50%;
      transform:translateX(-50%);
    }

    .content{
      color:#333;
      font-size:14px;
      line-height:32px;
      text-align:justify;

      &+.content{
        margin-top:20px;
      }
    }
  }

  .about-footer{
    background-color:white;
    padding:40px 0 100px 0;

    .title{
      text-align:center;
      font-size:24px;
      color:#333;
    }

    .body{
      width:940px;
      margin:45px auto 0 auto;
    }

    .concat{
      font-size:20px;
      color:#333;
      margin-top:20px;
      margin-right:553px;
      padding-left:35px;
      height:30px;
      line-height:30px;
      background:url(../assets/imgs/about-address.png) no-repeat left center;

      &+.concat{
        margin-top:30px;
        background-image:url(../assets/imgs/about-phone.png);
      }
    }

    .map {
      width: 500px;
      height: 333px;
    }

    hr{
      margin:35px 0;
      width:320px;
      border:none;
      border-top:1px dashed @border;
    }

    ul{
      list-style-type:disc;
      padding-left:25px;
      margin-right:553px;

      li{
        margin-top:30px;
        font-size:18px;
        color:#333;

        span{
          color:#777;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue